<template>
  <div class="wc-dialog-overlay" v-if="props.modelValue" @click.self="handleClose" @touchmove.prevent @wheel.prevent>

    <div class="share-dialog" @touchmove.stop @wheel.stop>
    <div class="share-dialog-content">
      <img src="~@/assets/imgs/act/mwr/share/facebook.png" @click="shareToFB" alt="facebook">
      <img src="~@/assets/imgs/act/mwr/share/x.png" @click="shareToX" alt="x(twitter)">
      <img src="~@/assets/imgs/act/mwr/share/whatsapp.png" @click="shareToWhatsApp" alt="whatsapp">
    </div>
  </div>

  </div>
</template>

<script setup>
  /* eslint-disable */

import { defineProps, defineEmits, computed, watch, onUnmounted } from 'vue'
import wcActApi from '@/config/wcActApi'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
const store = useStore()

// 禁止/恢复页面滚动
const lockScroll = () => {
  document.body.classList.add('no-scroll')
  document.documentElement.classList.add('no-scroll')
}

const unlockScroll = () => {
  document.body.classList.remove('no-scroll')
  document.documentElement.classList.remove('no-scroll')
}
const activityInfo = computed(() => store.state.wcAct.activityInfo || {})

const { t } = useI18n()

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  type: { // normal, shareDragon
    type: String,
    default: 'normal'
  },
  shareParams: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['update:modelValue', 'shareSuccess'])

const updateModelValue = (value) => {
  emit('update:modelValue', value)
}

const getShareUrl = async () => {
  try {
    const res = await wcActApi.share({
      ogTitle: t('wc2026.share.title').replace('_n_', activityInfo.value.winCheerCount),
      ogDescription:getShareText(),
      ogImage: 'xxx',
      targetUrl: window.location.href,
      ...props.shareParams,
    })
    return res.shortUrl || window.location.href
  } catch {
    return window.location.href
  }
}

const shareToFB = async () => {
  const shareUrl = await getShareUrl()
  emit('shareSuccess')
  const url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl)
  window.open(url, '_blank')
}

const shareToX = async () => {
  const shareUrl = await getShareUrl()
  emit('shareSuccess')
  const text = getShareText()
  const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(shareUrl)
    + '&text=' + encodeURIComponent(text)
  window.open(url, '_blank')
}

const shareToWhatsApp = async () => {
  const shareUrl = await getShareUrl()
  emit('shareSuccess')
  const text = getShareText()
  const url = 'https://wa.me/?text=' + encodeURIComponent(text + '\n' + shareUrl)
  window.open(url, '_blank')
}

const getShareText = () => {
  return t('wc2026.share.title').replace('_n_', activityInfo.value.winCheerCount) + ' ' + t('wc2026.share.description')
}

const handleClose = () => {
  emit("update:modelValue", false);
};

watch(() => props.modelValue, (val) => {
  if (val) {
    lockScroll()
  } else {
    unlockScroll()
  }
}, { immediate: true })

onUnmounted(() => {
  unlockScroll()
})
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
